import { render, staticRenderFns } from "./aiService.vue?vue&type=template&id=dec15f22&scoped=true"
import script from "./aiService.vue?vue&type=script&lang=js"
export * from "./aiService.vue?vue&type=script&lang=js"
import style0 from "./aiService.vue?vue&type=style&index=0&id=dec15f22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec15f22",
  null
  
)

export default component.exports